// extracted by mini-css-extract-plugin
export default {"button-box":"Button_button-box__QQftS","button":"Button_button__JBBzO","button-img":"Button_button-img__fKyur"};